module.exports = __webpack_public_path__ + "img/air-1.924040e8.webp";